import { RefObject, useState, useEffect, useCallback } from 'react'

export type TextOverflowAxis = 'horizontal' | 'vertical'

export function useTextOverflow<T extends HTMLElement>(
  ref: RefObject<T | null>,
  axis: TextOverflowAxis = 'horizontal'
) {
  const [isOverflowing, setIsOverflowing] = useState(false)

  const checkOverflow = useCallback(() => {
    const el = ref.current

    if (el) {
      setIsOverflowing(
        axis === 'vertical'
          ? el.scrollHeight > el.clientHeight
          : el.scrollWidth > el.clientWidth
      )
    }
  }, [ref, axis])

  useEffect(() => {
    checkOverflow()

    const el = ref.current

    if (!el) {
      return
    }

    const observer = new ResizeObserver(checkOverflow)
    observer.observe(el)

    return () => observer.disconnect()
  }, [checkOverflow])

  return isOverflowing
}
